import { ComplianceType } from '@mc-alberta/types';
export class ComplianceSettingsUtils {
    /**
     * Convert compliance settings from EMVCo v1.4 to a pseudo v0.9 format.
     */
    static transformToVersionPointNine(complianceSettings) {
        const complianceSettingsPointNine = {};
        if (this.hasRememberMeComplianceResource(complianceSettings)) {
            complianceSettingsPointNine.rememberMe = true;
        }
        return complianceSettingsPointNine;
    }
    /**
     * Whether or not compliance resources contains a REMEMBER_ME resource.
     */
    static hasRememberMeComplianceResource(complianceSettings) {
        var _a;
        return !!((_a = complianceSettings === null || complianceSettings === void 0 ? void 0 : complianceSettings.complianceResources) === null || _a === void 0 ? void 0 : _a.some((complianceResource) => {
            return complianceResource.complianceType === ComplianceType.REMEMBER_ME;
        }));
    }
}
